import { ElementProps } from '@/components/sections/builder/types';
import { FooterSectionImageType } from '@/components/sections/builder/elements/footer/footer/types';

import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import React from 'react';
import Image from 'next/image';
import InputTab from '@/components/sections/builder/settings/input-tab';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import { FLEX_ALIGN } from '@/components/sections/builder/constants/position';
import { shallow } from 'zustand/shallow';
import { Images } from 'lucide-react';
import ImageSetting from '@/components/sections/builder/settings/image-setting';

const defaultData: FooterSectionImageType = {
  name: 'Image',
  imgUrl: '/assets/select-photo.png',
  imgAlignment: 'center',
  imgWidth: 130,
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as FooterSectionImageType;

  return (
    <>
      <div className='section-footer-image-wrapper w-full'>
        <div className={cn('section-footer-image')}>
          <Image
            src={data.imgUrl as string}
            width={100}
            height={100}
            layout='responsive'
            alt='image-footer'
            className='w-full'
          />
        </div>
      </div>
      <style jsx>
        {`
          .section-footer-image-wrapper {
            display: flex;
            justify-content: ${FLEX_ALIGN[data.imgAlignment]};
          }
          .section-footer-image {
            max-width: min(100%, ${data.imgWidth}px);
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Images;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as FooterSectionImageType;

  return (
    <div>
      <div className='mb-2'>Image</div>
      <ImageSetting
        value={data?.imgUrl}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            imgUrl: val,
          })
        }
      />
      <div className='mb-2 mt-4'>Image Width</div>
      <InputSlider
        value={data.imgWidth || 0}
        min={50}
        max={300}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            imgWidth: val,
          })
        }
      />
      <div className='my-4'>Image alignment on large screen</div>
      <InputTab
        defaultValue={data.imgAlignment}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            imgAlignment: v,
          })
        }
      />
    </div>
  );
}

const FooterSectionImage = {
  type: 'footer_section_image',
  group: 'footer_section',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default FooterSectionImage;
